import { AxiosHeaders } from 'axios'
export const oneMBInBytes = 1048576 // 1MB (1024 * 1024)
export const maxFileSizeInBytes = oneMBInBytes * 10 // 10MB (1024 * 1024 * 10)

export const getFilename = (headers: AxiosHeaders) => {
    const contentDisposition = headers.get('Content-Disposition') as string

    if (contentDisposition) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(contentDisposition)

        if (matches != null && matches[1]) {
            return matches[1].replace(/['"]/g, '')
        }
    }
}

export const downloadFile = (blob: Blob, fileName: string) => {
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = fileName

    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    URL.revokeObjectURL(url)
}

export const validateFileSize = (file: File, maxFileSizeInBytes: number): boolean => {
    return file.size <= maxFileSizeInBytes
}
